<template>
  <BaseLayout show-navigation-content-when-mini>
    <template v-if="business">
      <BusinessSidebar slot="drawer-left" :committee-id="business.committee.id" />
      <v-card>
        <v-card-title
          ><h1 class="heading">{{ business.number }} {{ business.title }}</h1></v-card-title
        >
        <v-card-text>
          <v-row>
            <v-col>
              <h3 class="pa-3">{{ $t('business.attributes') }}</h3>
              <v-list class="meta-data-list">
                <div class="meta-data-item">
                  <v-list-item class="my-2">
                    <span class="font-weight-bold pr-2"> {{ $t('business.type') }}: </span
                    >{{ business.type ? business.type.title : '-' }}
                  </v-list-item>
                </div>
                <div class="meta-data-item">
                  <v-list-item class="my-2">
                    <span class="font-weight-bold pr-2"> {{ $t('business.committee') }}: </span
                    >{{ business.committee ? business.committee.title : '-' }}
                  </v-list-item>
                </div>
                <div class="meta-data-item">
                  <v-list-item class="my-2">
                    <span class="font-weight-bold pr-2"> {{ $t('business.sourceCommittee') }}: </span
                    >{{ business.source_committee ? business.source_committee.title : '-' }}
                  </v-list-item>
                </div>
              </v-list>
            </v-col>
            <v-col>
              <h3 class="pa-3">{{ $t('business.meetings') }}</h3>
              <v-list two-line>
                <template v-if="agendaItemGroups.length">
                  <template v-for="group in agendaItemGroups">
                    <v-list-item :key="`committee-${group.committee.id}`" disabled>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          {{ group.committee.title }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <template v-for="meeting in group.meetings">
                      <v-list-item :key="`meeting-${group.committee.id}-${meeting.id}`" class="pl-6">
                        <v-list-item-content>
                          <v-list-item-title class="text-wrap text-break">
                            <RouterLink
                              :to="{ name: 'meeting', params: { id: meeting.id } }"
                              dense
                              ripple
                              color="primary"
                            >
                              {{ meeting.title }}
                            </RouterLink>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ toLocaleDateTimeString(meeting.start) }} -
                            {{ toLocaleDateTimeString(meeting.concluded) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item v-for="agendaItem in meeting.agenda_items" :key="agendaItem.id" class="pl-10">
                        <v-list-item-content>
                          <v-list-item-title class="text-wrap text-break">
                            <RouterLink
                              :to="{ name: 'agendaitem', params: { id: agendaItem.id } }"
                              dense
                              ripple
                              color="primary"
                            >
                              {{
                                $t('business.agendaItem', {
                                  title: agendaItem.title,
                                })
                              }}
                            </RouterLink>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </template>
                </template>
                <v-list-item v-else>
                  <v-list-item-content>
                    <v-list-item-title>{{ $t('business.noAgendaItems') }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
  </BaseLayout>
</template>

<script>
import { createLink } from '@/api/helpers'
import { api } from '@/api'
import { toLocaleDateTimeString } from '@/filters'
import BusinessSidebar from '@/components/sidebars/BusinessSidebar.vue'

export default {
  name: 'Business',
  components: { BusinessSidebar },
  data() {
    return {
      agendaItemGroups: [],
      business: null,
      id: this.$route.params.id,
    }
  },
  async mounted() {
    await this.fetchBusiness()
    await this.fetchRelatedAgendaItems()
  },
  methods: {
    toLocaleDateTimeString,
    async fetchBusiness() {
      try {
        const response = await api.get(createLink('businesses/{id}', { id: this.id }))
        this.business = response.data
      } catch (e) {
        this.notifyError(this.$t('business.error.fetchBusiness'))
      }
    },
    async fetchRelatedAgendaItems() {
      try {
        const response = await api.get(createLink('businesses/{id}/related_agenda_items', { id: this.id }))
        this.agendaItemGroups = response.data
      } catch (e) {
        this.notifyError(this.$t('business.error.fetchAgendaItem'))
      }
    },
  },
}
</script>

<style scoped lang="scss">
.v-list-item {
  min-height: 0 !important;
}
.meta-data-list:deep(.meta-data-item) {
  &:not(:last-child) {
    border-bottom: solid var(--v-bodyBg-base) 1px;
  }
}
</style>
